<div class="not-found-container">
  <h1>404 - Page Not Found</h1>

  <i class="far fa-sad-cry"></i>

  <p>{{ redirectMessage }}</p>
</div>
